"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchCondition = _interopRequireDefault(require("01_core/components/layout/SearchCondition"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CMultiToggle = _interopRequireDefault(require("01_core/components/materials/CMultiToggle"));
var _CSwitch = _interopRequireDefault(require("01_core/components/materials/CSwitch"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _SelectKaishaSoshiki = _interopRequireDefault(require("01_core/components/select/SelectKaishaSoshiki"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _SelectGyomuContent = _interopRequireDefault(require("../../common/components/select/SelectGyomuContent"));
var _SelectKansaTgtNendo = _interopRequireDefault(require("../../common/components/select/SelectKansaTgtNendo"));
var _kansaConditionActions = require("../../common/kansaConditionActions");
var _kansaResultActions = require("../kansaResultActions");
const _excluded = ["unit"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class KansaResultSearchCondition extends _react.default.Component {
  constructor(props) {
    super(props);
    // 検索ボタン押下時のハンドラ
    _defineProperty(this, "onSearchClick", () => {
      const {
        saveShareCondition,
        searchConditions,
        closeInfoBar,
        resetPaging,
        search
      } = this.props;
      if (!search) {
        saveShareCondition(searchConditions);
        closeInfoBar();
        resetPaging();
      }
      const _this$props$searchCon = this.props.searchConditions,
        {
          unit
        } = _this$props$searchCon,
        rest = _objectWithoutProperties(_this$props$searchCon, _excluded);
      const param = _objectSpread(_objectSpread({}, rest), {}, {
        gyomuCd: searchConditions.gyomuCd,
        //業務内容
        kansaTgtNendo: searchConditions.kansaTgtNendo,
        //監査対象年度
        kansaKaishaCd: searchConditions.kansaKaishaCd,
        //監査部門 会社コード
        kansaBumonCd: searchConditions.kansaBumonCd,
        //監査部門 組織コード
        hikansaKaishaCd: searchConditions.hikansaKaishaCd,
        //被監査部門 会社コード
        hikansaBumonCd: searchConditions.hikansaBumonCd,
        //被監査部門 組織コード
        kansaTgtJigyoNm: searchConditions.kansaTgtJigyoNm,
        //監査対象事業名
        showSts: searchConditions.tantoOnlyFlg,
        //担当の監査対象事業のみ表示
        kansaSts: searchConditions.kansaSts,
        //監査状況
        kaitoSts: searchConditions.kaitoSts,
        //監査回答状況
        makeSts: searchConditions.makeSts,
        //監査結果作成状況
        planSts: searchConditions.planSts,
        //指摘事項改善　計画状況
        progSts: searchConditions.progSts,
        //指摘事項改善　進捗状況
        evalSts: searchConditions.evalSts //被監査部門責任者評価評価状況
      });
      this.executeSearchAPI(param);
    });
    _defineProperty(this, "executeSearchAPI", sendData => {
      const {
        intl,
        callAPI,
        openInfoBar,
        setSearchResult,
        search
      } = this.props;
      callAPI(_APIs.KANSA_RESULT_SEARCH, sendData).then(json => {
        if (json.status === _APIs.STATUS.SUCCESS) {
          setSearchResult(json.data);
          if (json.data.length === 0) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_NO_SEARCH_RESULT_MESSAGE
            }));
          } else {
            if (!search) {
              // 再検索でない場合のみ一覧へ遷移する制御を行う
              _windowUtil.default.scrollBelowElement(this.area.current);
            }
          }
        }
      });
    });
    // 検索条件変更時のハンドラ
    _defineProperty(this, "handleSearchConditionChange", key => {
      return value => {
        this.props.changeSearchCondition(key, value);
      };
    });
    /** 監査部門切り替え時 */
    _defineProperty(this, "changeAuditorKaishaSoshiki", _ref => {
      let {
        kaishaCd,
        soshikiCd,
        label
      } = _ref;
      const {
        changeSearchCondition
      } = this.props;
      changeSearchCondition('kansaKaishaCd', kaishaCd);
      changeSearchCondition('kansaBumonCd', soshikiCd);
      changeSearchCondition('kansaBumonNm', label);
    });
    /** 被監査部門切り替え時 */
    _defineProperty(this, "changeAuditeeKaishaSoshiki", _ref2 => {
      let {
        kaishaCd,
        soshikiCd,
        label
      } = _ref2;
      const {
        changeSearchCondition
      } = this.props;
      changeSearchCondition('hikansaKaishaCd', kaishaCd);
      changeSearchCondition('hikansaBumonCd', soshikiCd);
      changeSearchCondition('hikansaBumonNm', label);
    });
    this.form = /*#__PURE__*/(0, _react.createRef)();
    this.area = /*#__PURE__*/_react.default.createRef();
  }
  componentDidMount() {
    if (this.props.search) {
      this.onSearchClick();
    }
  }
  render() {
    const {
      intl,
      searchConditions,
      initNendo,
      nendoChange,
      getCodeItems
    } = this.props;

    // 検索条件
    const conditions = [
    /*#__PURE__*/
    // 業務内容
    _react.default.createElement(_SelectGyomuContent.default, {
      gyomuCdAvail: searchConditions.gyomuCdAvail,
      value: searchConditions.gyomuCd,
      onChange: this.handleSearchConditionChange('gyomuCd'),
      required: true
    }), null,
    /*#__PURE__*/
    //監査対象年度,監査テーマ
    _react.default.createElement(_SelectKansaTgtNendo.default, {
      kansaTgtNendo: searchConditions.kansaTgtNendo,
      isSelectable: true,
      onChange: nendoChange,
      setInitialValue: initNendo
    }),
    /*#__PURE__*/
    //監査テーマ
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_THEME_NM
      })
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, searchConditions.kansaThemeNm)),
    /*#__PURE__*/
    //監査部門選択
    _react.default.createElement(_SelectKaishaSoshiki.default, {
      titleText: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KANSA_BUMON
      }),
      buttonText: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KANSA_BUMON_SELECT
      }),
      displayLabel: true,
      label: searchConditions.kansaBumonNm,
      kaishaCd: searchConditions.kansaKaishaCd,
      soshikiCd: searchConditions.kansaBumonCd,
      kansaTgtNendo: searchConditions.kansaTgtNendo,
      onChange: this.changeAuditorKaishaSoshiki
    }),
    /*#__PURE__*/
    //被監査部門選択
    _react.default.createElement(_SelectKaishaSoshiki.default, {
      titleText: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON
      }),
      buttonText: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON_SELECT
      }),
      label: searchConditions.hikansaBumonNm,
      kaishaCd: searchConditions.hikansaKaishaCd,
      soshikiCd: searchConditions.hikansaBumonCd,
      kansaTgtNendo: searchConditions.kansaTgtNendo,
      onChange: this.changeAuditeeKaishaSoshiki
    }),
    /*#__PURE__*/
    //監査対象事業
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_AUDIT_BUSINESS
      })
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: searchConditions.kansaTgtJigyoNm,
      onChange: this.handleSearchConditionChange('kansaTgtJigyoNm')
    })), /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_AUDIT_ONLY_BUSINESS_SHOW
      }),
      checked: searchConditions.tantoOnlyFlg,
      onChange: this.handleSearchConditionChange('tantoOnlyFlg'),
      shiftLeft: true
    }),
    /*#__PURE__*/
    //監査結果作成状況
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_AUDIT_RESULTS_CREATION_STS
      })
    }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
      options: [...getCodeItems(_CodeConsts.CODE.KANSA_RSLT_STS.KBN)],
      selectedOption: searchConditions.makeSts,
      onSelectOption: this.handleSearchConditionChange('makeSts')
    })),
    /*#__PURE__*/
    //指摘事項改善 計画状況
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_IMPROVEMENT_POINTED_OUT_PLAN_STS
      })
    }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
      options: [...getCodeItems(_CodeConsts.CODE.KANSA_KZPLN_STS.KBN)],
      selectedOption: searchConditions.planSts,
      onSelectOption: this.handleSearchConditionChange('planSts')
    })),
    /*#__PURE__*/
    //指摘事項改善 進捗状況
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_IMPROVEMENT_POINTED_OUT_PLAN_PROGRESS
      })
    }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
      options: [...getCodeItems(_CodeConsts.CODE.KANSA_KZPRG_STS.KBN)],
      selectedOption: searchConditions.progSts,
      onSelectOption: this.handleSearchConditionChange('progSts')
    })),
    /*#__PURE__*/
    //被監査部門責任者評価評価状況
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_AUDITED_EVALUATION_STS
      })
    }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
      options: [...getCodeItems(_CodeConsts.CODE.KANSA_HYOKA_STS.KBN)],
      selectedOption: searchConditions.evalSts,
      onSelectOption: this.handleSearchConditionChange('evalSts')
    }))];
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.area
    }, /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
      conditions: conditions,
      onSearchClick: this.onSearchClick,
      returnHome: true
    }));
  }
}
const mapStateToProps = state => {
  return {
    searchConditions: state.kansaResult.searchConditions,
    search: state.kansaResult.search,
    permission: state.kansaResult.permission
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (key, value) => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    fixConditions: () => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.FIX_CONDITIONS]()),
    setSearchResult: resultList => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_SEARCH_RESULT](resultList)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    closeInfoBar: () => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.CLOSE]()),
    resetPaging: () => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.RESET_PAGING]()),
    nendoChange: (selectNendo, selectThemeNm) => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_NENDO](selectNendo, selectThemeNm)),
    initNendo: (selectNendo, selectThemeNm) => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.INIT_NENDO](selectNendo, selectThemeNm)),
    saveShareCondition: condition => dispatch(_kansaConditionActions.kansaConditionActions[_kansaConditionActions.TYPES_CONDITION.SAVE](condition))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(KansaResultSearchCondition))));